import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic';
import { useDispatch, useSelector } from 'react-redux';
import {
    convertToBill,
    convertToBillWithDate,
    createPurchaseOrder,
    fetchPurchaseOrder,
    fetchPurchaseOrders,
    getPurchaseOrder,
    updatePurchaseOrder,
    updatePurchaseOrderQuantity,
} from '../../app/reducers/PurchaseOrder/purchaseOrderSlice';
import { ClipLoader } from 'react-spinners';
import axios from 'axios';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import moment from 'moment';
import { customIDs } from '../../utils/customIds';

const SplitModal = ({ setSplitModal, viewSplitModal, title, data }) => {
    const dispatch = useDispatch();
    const [current, setCurrent] = useState(1);
    const [heading, setHeading] = useState('Edit Purchase Order');
    const [loading, setLoading] = useState(false);
    const [timeoutLoader, setTimeoutLoader] = useState(false);
    const { purchaseOrderLoading } = useSelector(getPurchaseOrder);
    const organization_id = 637857442;

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: data.purchaseorder_id,
            quantity: '',
            qty_taka: '',
            current_qty_taka: '',
            current_quantity: '',
            initialData: {},
        },
        onSubmit: async (values, { resetForm }) => {
            let currentQuarter = moment().quarter();
            let adjustedQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1;
            let adjustedYear =
                currentQuarter === 1 ? moment().year() - 1 : moment().year();
            let upData = {
                id: values.id,
                line_items: [
                    {
                        ...values.initialData.line_items[0],
                        rate:
                            (formik.values.initialData.line_items[0]
                                .item_custom_fields[1].value *
                                values.qty_taka *
                                formik.values.initialData.line_items[0]
                                    .item_custom_fields[2].value) /
                            100,
                        item_custom_fields: [
                            ...values.initialData.line_items[0]
                                .item_custom_fields,
                            {
                                customfield_id:
                                    customIDs.purchase_item_qty_taka,
                                value: values.qty_taka,
                            },
                        ],
                        quantity: values.quantity,
                    },
                ],
                custom_fields: [
                    ...values.initialData.custom_fields,
                    {
                        customfield_id: customIDs.purchase_custom_qty_taka,
                        value: values.qty_taka,
                    },
                    {
                        customfield_id: customIDs.purchase_custom_split,
                        value: 'true',
                    },
                    {
                        customfield_id: customIDs.purchase_system_generated,
                        value: 'yes',
                    },
                ],
                date: moment()
                    .year(adjustedYear)
                    .quarter(adjustedQuarter)
                    .endOf('quarter')
                    .format('YYYY-MM-DD'),
                delivery_date: moment()
                    .year(adjustedYear)
                    .quarter(adjustedQuarter)
                    .endOf('quarter')
                    .format('YYYY-MM-DD'),
            };
            if (
                values.qty_taka != values.current_qty_taka &&
                values.quantity != 105
            ) {
                await dispatch(updatePurchaseOrderQuantity(upData));
                await waModified(data);
                setTimeoutLoader(true);
                await new Promise((resolve) =>
                    setTimeout(async () => {
                        await dispatch(
                            convertToBillWithDate({
                                id: values.id,
                                date: moment()
                                    .year(adjustedYear)
                                    .quarter(adjustedQuarter)
                                    .endOf('quarter')
                                    .format('YYYY-MM-DD'),
                            })
                        );
                        setTimeoutLoader(false);
                        resolve();
                    }, 200)
                );
            } else if (values.qty_taka != values.current_qty_taka) {
                await dispatch(updatePurchaseOrderQuantity(upData));
                await waModified(data);
            } else if (values.quantity != 105) {
                await dispatch(updatePurchaseOrderQuantity(upData));
                setTimeoutLoader(true);
                new Promise((resolve) =>
                    setTimeout(async () => {
                        await dispatch(
                            convertToBillWithDate({
                                id: values.id,
                                date: moment()
                                    .year(adjustedYear)
                                    .quarter(adjustedQuarter)
                                    .endOf('quarter')
                                    .format('YYYY-MM-DD'),
                            })
                        );
                        setTimeoutLoader(false);
                        resolve();
                    }, 200)
                );
            }
            setHeading('Create Purchase Order');
            setCurrent(2);
        },
    });

    const formik2 = useFormik({
        enableReinitialize: true,
        initialValues: {
            quantity: '',
            qty_taka: '',
        },
        validationSchema: Yup.object({
            quantity: Yup.number().required(),
            qty_taka: Yup.number().required(),
        }),
        onSubmit: async (values, { resetForm }) => {
            setLoading(true);
            let currentQuarter = moment().quarter();
            let adjustedQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1;
            let adjustedYear =
                currentQuarter === 1 ? moment().year() - 1 : moment().year();

            let createData = {
                vendor_id: formik.values.initialData.vendor_id,
                payment_terms: parseInt(
                    formik.values.initialData.payment_terms
                ),
                payment_terms_label:
                    formik.values.initialData.payment_terms_label,
                date: moment()
                    .year(adjustedYear)
                    .quarter(adjustedQuarter)
                    .startOf('quarter')
                    .format('YYYY-MM-DD'),
                delivery_date: moment().add(12, 'days').format('YYYY-MM-DD'),
                delivery_customer_id:
                    formik.values.initialData.delivery_customer_id,
                line_items: [
                    {
                        description:
                            formik.values.initialData.line_items[0].description,
                        account_id: customIDs.purchase_item_account_id,
                        rate:
                            (formik.values.initialData.line_items[0]
                                .item_custom_fields[1].value *
                                values.qty_taka *
                                formik.values.initialData.line_items[0]
                                    .item_custom_fields[2].value) /
                            100,
                        quantity: values.quantity,
                        item_custom_fields: [
                            {
                                customfield_id:
                                    customIDs.purchase_item_unit_rate,
                                value: formik.values.initialData.line_items[0]
                                    .item_custom_fields[1].value,
                            },
                            {
                                customfield_id:
                                    customIDs.purchase_item_qty_taka,
                                value: values.qty_taka,
                            },
                            {
                                customfield_id:
                                    customIDs.purchase_item_commission,
                                value: formik.values.initialData.line_items[0]
                                    .item_custom_fields[2].value,
                            },
                            {
                                customfield_id:
                                    customIDs.purchase_item_vendorName,
                                value: formik.values.initialData.line_items[0]
                                    .item_custom_fields[3].value,
                            },
                        ],
                    },
                ],
                custom_fields: [
                    {
                        customfield_id: customIDs.purchase_system_generated,
                        value: 'yes',
                    },
                    {
                        customfield_id: customIDs.purchase_custom_buyerName,
                        value: formik.values.initialData.custom_fields.find(
                            (d) => d.label == 'BUYER NAME'
                        )?.value,
                    },
                    {
                        customfield_id: customIDs.purchase_custom_qty_taka,
                        value: values.qty_taka,
                    },
                    {
                        customfield_id: customIDs.purchase_custom_quality,
                        value: formik.values.initialData.custom_fields.find(
                            (d) => d.label == 'QUALITY NAME'
                        )?.value,
                    },
                    {
                        customfield_id: customIDs.purchase_custom_rate,
                        value: formik.values.initialData.custom_fields.find(
                            (d) => d.label == 'RATE'
                        )?.value,
                    },
                    {
                        customfield_id: customIDs.purchase_custom_split,
                        value: 'true',
                    },
                    {
                        customfield_id: customIDs.purchase_custom_payment_terms,
                        value: parseInt(
                            formik.values.initialData.payment_terms
                        ),
                    },
                    {
                        customfield_id:
                            customIDs.purchase_custom_commission_collection,
                        value: formik.values.initialData.custom_fields.find(
                            (d) => d.label == 'commission collection'
                        )?.value,
                    },
                    {
                        customfield_id:
                            customIDs.purchase_custom_vendor_commision,
                        value: formik.values.initialData.custom_fields.find(
                            (d) => d.label == 'Vendor Commission'
                        )?.value,
                    },
                ],
            };
            const purchaseOrder = await dispatch(
                createPurchaseOrder(createData)
            );
            if (purchaseOrder?.payload) {
                let updtData = await dispatch(
                    updatePurchaseOrder({
                        id: purchaseOrder?.payload?.purchaseorder
                            .purchaseorder_id,
                        status: 'open',
                    })
                );
                if (updtData?.payload) {
                    if (values.quantity != 105) {
                        setTimeoutLoader(true);
                        await new Promise((resolve) =>
                            setTimeout(async () => {
                                await dispatch(
                                    convertToBillWithDate({
                                        id: purchaseOrder?.payload
                                            ?.purchaseorder.purchaseorder_id,
                                        date: moment()
                                            .year(adjustedYear)
                                            .quarter(adjustedQuarter)
                                            .startOf('quarter')
                                            .format('YYYY-MM-DD'),
                                    })
                                );
                                setTimeoutLoader(false);
                                resolve();
                            }, 400)
                        );
                    }
                }
            }
            await dispatch(
                fetchPurchaseOrders({
                    page: data.page,
                    status: 'open',
                    date_start: moment()
                        .year(adjustedYear)
                        .quarter(adjustedQuarter)
                        .startOf('quarter')
                        .format('YYYY-MM-DD'),
                    date_end: moment()
                        .year(adjustedYear)
                        .quarter(adjustedQuarter)
                        .endOf('quarter')
                        .format('YYYY-MM-DD'),
                })
            );
            setLoading(false);
            setCurrent(1);
            setHeading('Edit Purchase Order');
            setSplitModal(false);
        },
    });

    useEffect(async () => {
        if (data.purchaseorder_id) {
            const action = await dispatch(
                fetchPurchaseOrder({ id: data.purchaseorder_id })
            );
            if (action.payload.purchaseorder) {
                formik.setFieldValue(
                    'quantity',
                    action.payload.purchaseorder.total_quantity
                );
                formik.setFieldValue(
                    'current_quantity',
                    action.payload.purchaseorder.total_quantity
                );
                formik.setFieldValue(
                    'qty_taka',
                    action.payload.purchaseorder.custom_fields[1].value
                );
                formik.setFieldValue(
                    'current_qty_taka',
                    action.payload.purchaseorder.custom_fields[1].value
                );
                formik.setFieldValue(
                    'initialData',
                    action.payload.purchaseorder
                );
            }
        }
    }, [data.purchaseorder_id]);

    const waModified = async (row) => {
        // const action = await dispatch(fetchPurchaseOrder({id:row.purchaseorder_id}))
        // if(action.payload?.purchaseorder) {
        const vendorCheck = await axios.get(
            `https://app2.com.bot/webhook/641a5e12a52b8e34db70b32c?contact_type=vendor&po_id=${formik.values.initialData.purchaseorder_id}&org_id=${organization_id}&contact_id=${formik.values.initialData.vendor_id}&delivery_date=${formik.values.initialData.delivery_date}`
        );
        if (vendorCheck.data?.accepted) {
            toast.success('Vendor True');
        } else {
            toast.error('Not accepted try again');
        }
        const customerCheck = await axios.get(
            `https://app2.com.bot/webhook/641a5e12a52b8e34db70b32c?contact_type=customer&po_id=${formik.values.initialData.purchaseorder_id}&org_id=${organization_id}&contact_id=${formik.values.initialData.delivery_customer_id}&delivery_date=${formik.values.initialData.delivery_date}`
        );
        if (customerCheck.data?.accepted) {
            toast.success('Customer True');
        } else {
            toast.error('Not accepted try again');
        }
        // }else{
        //   toast.error("Something Went Wrong.Please try again")
        // }
    };

    return (
        <ModalBasic
            title={heading}
            modalOpen={viewSplitModal}
            setModalOpen={setSplitModal}
        >
            {current == 1 &&
                (purchaseOrderLoading || timeoutLoader ? (
                    <ClipLoader />
                ) : (
                    <form
                        className="flex flex-col gap-4 p-4"
                        onSubmit={formik.handleSubmit}
                    >
                        <FormikInputGroup
                            label="PO Number"
                            formik={formik}
                            type="number"
                            name="id"
                            readOnly
                        />
                        <FormikInputGroup
                            label="Quantity Meter"
                            formik={formik}
                            type="number"
                            name="quantity"
                        />
                        <FormikInputGroup
                            label="Quantity Taka"
                            formik={formik}
                            type="number"
                            name="qty_taka"
                        />
                        <div>
                            <PrimaryButton type="submit">Submit</PrimaryButton>
                        </div>
                    </form>
                ))}
            {loading || timeoutLoader ? (
                <ClipLoader />
            ) : (
                current == 2 && (
                    <div>
                        <form
                            className="flex flex-col gap-4 p-4"
                            onSubmit={formik2.handleSubmit}
                        >
                            <FormikInputGroup
                                label="Quantity Meter"
                                formik={formik2}
                                type="number"
                                name="quantity"
                            />
                            <FormikInputGroup
                                label="Quantity Taka"
                                formik={formik2}
                                type="number"
                                name="qty_taka"
                            />
                            <div>
                                <PrimaryButton type="submit">
                                    Submit
                                </PrimaryButton>
                            </div>
                        </form>
                    </div>
                )
            )}
        </ModalBasic>
    );
};

export default SplitModal;
